import { hasQBData, hasStoriesData, formOptionsData, formAddOnsData } from 'state/reducers/embedsState/embedManagementState/contentStatus/content_status_helpers';


// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

export const getDefaultState = () => ({
    activeSelection: 'none', // none, background, questionImage, option_0, option_1, option_2, option_3
    contentChangeDetected: false,
    contents : { // 'contents' is a historical name of this property. In previous workflow variations Pages were called Contents.
        '0': formSingleContentData({ contentData: null, contentProperties: null, contentId: '0', type: 'quiz', position: 0 })
    },
    addons: formAddOnsData(null),
    sortedContents: {},
    fetchingSortedContent: false,
    updatedContents: [],
    newContents: [],
    firstLiveContentId: 0,
    lastQueuePosition: 0,
    noLiveContents: null,
    selectedContent: null,
    totalNumberOfContents: 0,
    settingCustomEmailCollectionImage: false,
    previewEmailCollectionBackgroundImageURL: null,
    uploadingCustomImage: false
});


// HELPER METHODS TO FORM A DEFAULT STATE AND/OR TRANSPILE THE DATA RECEIVED FROM THE BE

// Forming a page (content) blob.
//      `contentData` parameter is used to form the page (content) blob of the data received from the BE
//      `type` and `position` parameters are used to form the blob for a newly added page (quiz/poll question or story)
export const formSingleContentData = ({ contentData, contentProperties, contentId, type, position }) => ({
    contentId,
    contentType: !!contentData ? contentData.contentType.toLowerCase() : `${type}`,
    originalType:  !!contentData ? contentData.contentType.toLowerCase() : null,

    // Id of the created offline blob when content type changes for the content received from the BE.
    offlineBlobId: null,

    // Parent of the offline blob. Set on the content type change by the initial content received from the BE.
    parentId: null,

    // Properties responsible for the position and visibility of the page are shared.
    contentLive: !!contentData ? contentData.contentLive : true,
    queuePosition: !!contentData ? contentData.queuePosition : position,

    storyURLDataReceived: null,

    // Properties unique to question based (quiz / poll) content types.
    questionBased: {
        // Background
        imageProvider: hasQBData(contentData) ? contentProperties.imageProvider : null, // [USAToday, SIPA]
        imageID: hasQBData(contentData) ? contentProperties.imageID : null,
        imageURL: hasQBData(contentData) ? contentProperties.imageURL : null,
        backgroundImageURL: hasQBData(contentData) ? contentProperties.backgroundImageURL : null,
        currentBackgroundImage: hasQBData(contentData) ? contentProperties.currentBackgroundImage : null,
        backgroundColor: hasQBData(contentData) ? contentProperties.backgroundColor : 'rgba(48,48,48,0.8)',
        previewBackgroundImageURL: null,
        isDuplicate: false,
        isValid: null,
        type: hasQBData(contentData) ? contentProperties.type.toLowerCase() : 'image1', // question layout type: image1, image2, text1, text2, emoji
        contentUUID: hasQBData(contentData) ? contentData.contentUUID : null,
        correctOptionSelected: hasQBData(contentData) ? contentData.contentType === 'QUIZ' ? true : null : null,
        title: hasQBData(contentData) ? contentProperties.title : null,
        isTitleValid: hasQBData(contentData) && !!contentProperties.title ? true : null,
        totalNumberAnswered: hasQBData(contentData) && typeof contentData.engagement !== 'undefined' ? contentData.engagement : null,
        options: formOptionsData(hasQBData(contentData) ? contentProperties.options : null),

    },

    // Properties unique to stories.
    story: {
        // Background
        imageProvider: hasStoriesData(contentData) ? contentProperties.imageProvider : null, // [USAToday, SIPA]
        imageID: hasStoriesData(contentData) ? contentProperties.imageID : null,
        imageURL: hasStoriesData(contentData) ? contentProperties.imageURL : null,
        backgroundImageURL: hasStoriesData(contentData) ? contentProperties.backgroundImageURL : null,
        currentBackgroundImage: hasStoriesData(contentData) ? contentProperties.currentBackgroundImage : null,
        backgroundColor: hasStoriesData(contentData) ? contentProperties.backgroundColor : 'rgba(48,48,48,0.8)',
        previewBackgroundImageURL: null,
        clicks: hasStoriesData(contentData) ? contentData.engagement : 0,
        isValid: null,
        contentUUID: hasStoriesData(contentData) ? contentData.contentUUID : null,
        title: hasStoriesData(contentData) ? contentProperties.title : null,
        isTitleValid: hasStoriesData(contentData) && !!contentProperties.title ? true : null,
        ctaText: hasStoriesData(contentData) ? !!contentProperties.ctaText ? contentProperties.ctaText : null : 'Read More',
        isCTAValid: !!hasStoriesData(contentData),
        url: hasStoriesData(contentData) ? contentProperties.storyURL : null,
        isURLValid: hasStoriesData(contentData) && !!contentProperties.storyURL ? true : null,
    }
});

//default emojis for poll emoji type:

const defaultEmojis = ['😀',  '🤣', '🙁', '😜'];

// Forms a status blob for each question option.
// Used as a helper method to:
//      - form default status
//      - transpile received data
//      - to add a new option

export const formSingleOptionData = (optionData, idx) => ({
    isValid: !!optionData ? true : null,
    optionUUID: !!optionData ? optionData.optionUUID : null,
    text: !!optionData ? optionData.text : null,
    imageProvider: !!optionData ? optionData.imageProvider : null,
    imageID: !!optionData ? optionData.imageID : null,
    imageURL: !!optionData ? optionData.imageURL : null,
    currentImageURL: !!optionData ? optionData.currentImageURL : null,
    emoji: !!optionData && optionData.emoji != null ? optionData.emoji : defaultEmojis[idx],
    correctOption: !!optionData ? optionData.correctOption : false,
    isDuplicate: !!optionData ? optionData.isDuplicate : false,
    previewImageURL: null,
    position: !!optionData && !isNaN(optionData.position)  ? optionData.position : idx,
    // Replace this "optionData.numOfTimesChosen" with "Math.floor(Math.random() * Math.floor(99)) + optionData.numOfTimesChosen" to get dummy data for no. of times an option is chosen
    numOfTimesChosen: !!optionData && typeof optionData.numOfTimesChosen !== 'undefined' ? optionData.numOfTimesChosen : null
});
